import { jsx as _jsx } from "preact/jsx-runtime";
import { memoNamed } from '@noshiro/preact-utils';
import { lastUpdated } from '../assets';
export const LastUpdated = memoNamed('LastUpdated', () => (_jsx("div", { children: `（最終更新日：${lastUpdated}）` })));
